import { useEffect, useId, useState } from "react";

import { Badge, Icon } from "@/comn/components";
import { useAuth, usePage } from "@/comn/hooks";
import { api } from "@/comn";
import { Link } from "react-router-dom";
import { useMenu } from "@/comn/features/config/MenuConfig";

export const HeaderIQSButton = () => {
    const [open, setOpen] = useState(false);
    const handleClick = () => {};
    const [iqsData, setIqsData] = useState([]);
    const { root } = useMenu();

    useEffect(() => {
        if (root) {
            iconOpenCheck();
        }
    }, [root]);

    // useEffect(() => {
    //     if(open){
    //         getIqsList();
    //     }
    // }, [open]);

    const iconOpenCheck = async () => {
        setOpen(containsString(root, "menu_ptli0006"));
    };

    function containsString(obj: any, target: string): boolean {
        if (typeof obj === "string") {
            return obj.includes(target);
        }

        if (Array.isArray(obj)) {
            return obj.some((item) => containsString(item, target));
        }

        if (typeof obj === "object" && obj !== null) {
            return Object.values(obj).some((value) => containsString(value, target));
        }

        return false;
    }

    const getIqsList = async () => {
        try {
            const base = process.env.REACT_APP_API_OSCI || "";
            const path = "/api/v1/osci/ptl/myiqs/main/iqsList";
            const response = await api.get(base + path);
            setIqsData(response.data.myIqsList.content);
        } catch (error) {
            // console.log(error);
        }
    };

    const number = iqsData.length || undefined;

    return (
        <>
            {open && (
                <div className="group relative">
                    {/* <Badge number={number}> */}
                    <Link
                        to={`${process.env.REACT_APP_API_FRONT_PTLI}/ptli/mypage/myiqs/ptli0304001q?menuId=menu_ptli0006`}
                    >
                        <button
                            type="button"
                            className="flex items-center justify-center bg-header rounded h-[32px] w-[32px] hover:bg-black/10 transition-colors"
                        >
                            <Icon icon="clipboard" className="text-text" onClick={handleClick} />
                        </button>
                    </Link>
                    {/* </Badge> */}
                    {/* {number && (
                        <div className="z-[9999] absolute border shadow top-full left-0 w-60 rounded bg-navigation hidden group-hover:block">
                            <div className="p-2 text-lg font-bold">IQS Count : {number}</div>
                            <ul className="divide-y max-h-[480px] overflow-y-auto">
                                {iqsData.map((obj: any, index) => {
                                    return (
                                        <li
                                            key={id + index}
                                            className="p-2 cursor-pointer hover:bg-background [&_div]:hover:underline"
                                        >
                                            <Link to={`${process.env.REACT_APP_API_FRONT_PTLI}/ptli/mypage/myiqs/ptli0304002s/${obj.iqsId}?menuId=menu_ptli0006`}>
                                                <span className="text-sm text-darkgray">{obj.frstRgsrDtm}</span>
                                                <div className="font-semibold">{obj.reffNo}</div>
                                            </Link>
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                    )} */}
                </div>
            )}
        </>
    );
};
